<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Zahlungs-Management

  section.modal-card-body
    ValidationObserver(ref="form")
      .generic-wrapper
        .container
          .two-column
            .column
              .form.w512
                h2.title.is-6 Zahlungsdetails
                b-field(grouped)
                  ValidationProvider(name="Zahlungsmethode" rules="required" v-slot="{ errors, valid }") 
                    b-field(label="Zahlungsmethode" label-position="on-border"
                            :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                      b-select(v-model="formData.type")
                        option(value="cash") Barzahlung
                        option(value="bankwire") Überweisung
                        option(value="creditCard") Kreditkarte
                        option(value="ecCard") EC-Karte
                  .spacer.sm
                  ValidationProvider(
                    name="Zahlungseingang",
                    rules="required",
                    v-slot="{ errors, valid }")
                    b-field(
                      label="Zahlungseingang",
                      label-position="on-border",
                      :type="{ 'is-danger': errors[0], 'is-success': valid }",
                      :message="errors")
                      v-date-picker(v-model="formData.paymentDate" :popover="popoverConfig")
                        template(#default='{ inputValue, inputEvents }')
                          input.input(:value='inputValue' v-on='inputEvents')
                ValidationProvider(
                  name="Preis (€)",
                  :rules="{ required: true, currency: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(\.[0-9]{2})?$/ }",
                  v-slot="{ errors, valid }")
                  b-field(
                    label="Preis (€)",
                    label-position="on-border",
                    :type="{ 'is-danger': errors[0], 'is-success': valid }",
                    :message="errors")
                    b-input(v-model="formData.total" ref="priceInput")
                ValidationProvider(name="Kommentar" rules="" v-slot="{ errors, valid }") 
                  b-field(label="Kommentar" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.comment" type="textarea" maxlength="1000")
                .spacer.md
                PaymentInfoWidget(:booking="fullBooking" @copyNumber="(number) => formData.total = number" :newPayment="{...formData, total: formData.total * 100, createdAt: new Date()}")
                .spacer.sm
                h2.title.is-6 Bereits getätigte Zahlungen
                BookingPayments(v-if="formData.total >= 0 && formData.total" :payment="{...formData, total: formData.total * 100, createdAt: new Date()}" newPayment)
                BookingPayments(v-if="fullBooking && fullBooking.payments" v-for="payment in fullBooking.payments" :payment="payment" @updatePayment="reloadBooking()")
            .column
              .form.w640
                h2.title.is-6 E-Mail schreiben
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subject")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.body" :editorOptions="editorOptions")

      
  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-secondary(@click="sendPayment()") Speichern ohne Senden
    button.button.is-primary(@click="sendPayment('sendEmail')") Senden & Speichern
</template>

<script>
import { DateTime } from 'luxon';
import PaymentInfoWidget from "@/components/atoms/PaymentInfoWidget.vue";
import BookingPayments from "@/components/molecules/BookingPayments.vue";

export default {
  components: {
    PaymentInfoWidget,
    BookingPayments
  },
  props: {
    booking: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isModalActive: false,
      fullBooking: {},
      formData: {
        subject: 'Unser Angebot zu Ihrer Anfrage - '+this.booking.rentObject.name,
        body: null,
        type: 'bankwire',
        total: null,
        paymentDate: new Date(),
        comment: null
      },
      popoverConfig: {
        visibility: 'focus',
        showDelay: 0,
        hideDelay: 1,
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  async mounted() {
    this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
    const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
    let contractTemplate = emailTemplates.find(e => e.uuid === 'PAYMENT_EMAIL');
    const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: contractTemplate, booking: this.booking});
    this.formData.subject = result.template.subject;
    this.formData.body = result.template.body;
    this.$refs.priceInput.focus();
  },
  methods: {
    async reloadBooking() {
      this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
    },
    sendPayment(sendEmail) {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        const loadingComponent = this.$buefy.loading.open();
        const centPrice = parseInt(this.formData.total.replace(",", ".") * 100);
        this.formData.paymentDate = DateTime.fromJSDate(this.formData.paymentDate);
        await this.$store.dispatch("payments/create", {...this.formData, paymentDate: this.formData.paymentDate.toISODate(), total: centPrice, rentObjectBookingId: this.booking.id, sendEmail});
        loadingComponent.close();
        
        this.$emit('refreshInbox');
        this.$emit('close');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}

.payments {
  .payment {
    padding: $xs-space;
    background-color: $light;
    border-radius: 3px;
    margin-bottom: $xs-space;
    .p-date {
      color: $darkgray;
      font-size: 0.8rem;
    }
    .p-comment {
      color: $darkgray;
    }
    .p-total {
      font-weight: 500;
    }
  }
}
</style>